import { BadgeCheck, Calendar, Mail, MapPin, Pencil, Phone } from "lucide-react";
import type { CandidateProfileData } from "../../../types/candidateProfile.types";

interface ProfileHeroProps {
  profile: CandidateProfileData;
  onEdit?: () => void;
}

export default function ProfileHero({ profile, onEdit }: ProfileHeroProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-5">
          {profile.photoUrl ? (
            <img src={profile.photoUrl} alt={profile.name} className="h-24 w-24 rounded-full border-4 border-blue-100 object-cover" />
          ) : (
            <div className="flex h-24 w-24 items-center justify-center rounded-full border-4 border-blue-100 bg-slate-100 text-xl font-bold text-slate-600">
              {(profile.name || "C").split(" ").map((part) => part[0]).slice(0, 2).join("")}
            </div>
          )}
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="text-3xl font-bold text-slate-900">{profile.name}</h1>
              <BadgeCheck size={20} className="text-blue-600" />
            </div>
            <p className="mt-1 text-base font-medium text-blue-600">{profile.designation || "Designation not added"}</p>
            <div className="mt-4 flex flex-wrap gap-3 text-sm text-slate-600">
              <span className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2"><Mail size={15} />{profile.email || "Email not added"}</span>
              <span className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2"><Phone size={15} />{profile.phone || "Phone not added"}</span>
              <span className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2"><MapPin size={15} />{profile.location || "Location not added"}</span>
              <span className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2"><Calendar size={15} />{profile.experienceYears || "Experience not added"}</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-start gap-4 lg:items-end">
          <button type="button" onClick={onEdit} className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700">
            <Pencil size={16} />Edit Profile
          </button>
          <div className="rounded-xl border border-green-200 bg-green-50 px-5 py-4">
            <p className="text-xs uppercase tracking-wide text-slate-500">ATS SCORE</p>
            <h2 className="mt-1 text-3xl font-bold text-green-600">{Number(profile.atsScore) || 0}%</h2>
            <p className="mt-1 text-sm text-slate-600">ATS analysis score</p>
          </div>
        </div>
      </div>
    </div>
  );
}
